import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=4eb4a988"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
import style0 from "./Service.vue?vue&type=style&index=0&id=4eb4a988&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb4a988')) {
      api.createRecord('4eb4a988', component.options)
    } else {
      api.reload('4eb4a988', component.options)
    }
    module.hot.accept("./Service.vue?vue&type=template&id=4eb4a988", function () {
      api.rerender('4eb4a988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/Service.vue"
export default component.exports